/* eslint-disable */
<template>
  <div v-if="calcDates">
    <div class="flex items-center justify-end gap-4">
      <div>
        <CustumSelect
          :key="spot"
          name="spots"
          placeholder="select type "
          :data="spacesData"
          :defaultData="spot"
          :rules="{
            required: false,
          }"
          @setInput="setInput"
          :disabled="connectedCharts"
        />
      </div>
      <div v-if="!chartConnected">
        <Select
          mode="multiple"
          style="width: 100%"
          class="min-w-[130px]"
          v-if="searchDayShow"
          placeholder="Please select"
          :options="searchDayData"
          @change="handleChange"
        >
        </Select>
      </div>
      <date-picker
        v-if="slideType !== 'Initial' && slideType !== 'Range'"
        v-model:value="year"
        picker="year"
        :allowClear="false"
      />
    </div>

    <div
      v-if="query && (query.isFetching || query.isLoading)"
      class="flex items-center justify-center py-28 md:py-32 lg:py-36"
    >
      <Spin spinning size="large" />
    </div>

    <QueryAlert :query="query" />

    <div class="min-w-[400px] overflow-x-auto">
      <DonutChart
        v-if="chartData"
        :labelText="totalCommuters"
        :data="chartData"
        :key="componentKey"
      />

      <div v-if="chartData === 0" class="py-24 md:py-28 lg:py-32">
        <Empty />
      </div>

      <div class="mt-4 flex items-center gap-1 text-white" v-if="this.spot !== 5 && this.spot !== 6">
        <span
          v-if="this.spot !== 4"
          class="bg-primary-light hover:bg-primary h-7 px-4 rounded flex items-center justify-center"
          :class="
            !showArrows[0] && this.spot !== 3 ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'
          "
          @click="this.goPrevStep"
        >
          <PhArrowLeft weight="bold" size="18" />
        </span>
        <Transition v-if="this.spot !== 3" :key="sliderData[slideType][slideIndex]">
          <h3
            :key="sliderData[slideType][slideIndex]"
            class="fade-in-out bg-primary-light text-center text-white h-7 rounded flex-1 flex items-center justify-center"
            @dblclick="goToCurrentWeek"
          >
            {{ sliderData[slideType][slideIndex] }}
          </h3>
        </Transition>

        <span
          v-if="this.spot !== 4"
          class="bg-primary-light hover:bg-primary h-7 px-4 rounded flex items-center justify-center"
          :class="
            !showArrows[1] && this.spot !== 3 ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'
          "
          @click="this.goNextStep"
        >
          <PhArrowRight weight="bold" size="18" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import dayjs from 'dayjs';

import { STATS } from '@/store/types';
import CustumSelect from '@/components/shared/form/CustumSelect.vue';
import { PhArrowLeft, PhArrowRight } from 'phosphor-vue';
import { Spin, DatePicker, Empty, Select } from 'ant-design-vue';
import QueryAlert from '@/components/shared/QueryAlert.vue';

import { sortAndNameMonthes } from '@/utils/monthes';
import DonutChart from '../../shared/DonutChart.vue';
import debounce from 'lodash.debounce';
// import COLORS from '../../shared/COLORS';

export default {
  components: {
    CustumSelect,
    PhArrowLeft,
    PhArrowRight,
    DonutChart,
    QueryAlert,
    Spin,
    DatePicker,
    Select,
    Empty,
  },
  props: {
    initialTitle: String,
    query: Object,
    data: Object,
    defaultYear: {
      type: [String, Object],
      default: () => dayjs(),
    },
    searchDayShow: {
      type: Boolean,
      default: false,
    },
    showYearly: {
      type: Boolean,
      default: false,
    },
    connectedCharts: {
      type:Boolean,
      default: false,
    },
    defaultType: {
      type: String,
      default: 'Monthly',
      // Monthly Quarterly Yearly Initial
    },
    startMonth: {
      type: Number,
      default: 1,
    },
    defaultIndex: {
      type: Number,
      default: null,
    },
    defaultRange: {
      type: Array,
      default: () => null,
    },
    showInitial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      year: dayjs(),
      spot: 1,
      searchDay: null,
      spacesData: [
        { id: 10, name: 'Weekly' },
        { id: 1, name: 'Monthly' },
        { id: 2, name: 'Quarterly' },
      ],
      searchDayData: [
        { id: 1, value: 'Sunday' },
        { id: 2, value: 'Monday' },
        { id: 3, value: 'Tuesday' },
        { id: 4, value: 'Wednesday' },
        { id: 5, value: 'Thursday' },
        { id: 6, value: 'Friday' },
        { id: 7, value: 'Saturday' },
      ],

      sliderData: {
        Monthly: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        Quarterly: ['First quarter', 'Second quarter', 'Third quarter', 'Fourth quarter'],
        Yearly: ['2022', '2023', '2024', '2025'].reverse(),
        Initial: ['Initial Mode Share'],
        Weekly: this.getWeeksOfYear(this.getYear),
      },
      slideType: 'Monthly',
      slideIndex: 0,
      componentKey: 0,
    };
  },

  created() {
    if (this.initialTitle) {
      this.sliderData.Initial = [this.initialTitle];
    }
    if (this.defaultYear) {
      this.year = this.defaultYear;
    }

    if (this.defaultType && this.defaultType === 'Initial') {
      this.spacesData.push({ id: 4, name: 'Initial' });
    }
    if (this.showInitial) {
      this.spacesData.push({ id: 4, name: 'Initial' });
    }
    if (this.defaultType === 'Range') {
      this.spacesData.push({ id: 6, name: 'Custom Range' });
    }
    this.debouncedHandleChange = debounce((value) => {
      this.searchDay = value;
      this.$store.commit(STATS.SET_EMPLOYER_DAY_SEARCH_QUERY, value);
    }, 500); // 300ms delay - adjust as needed
    if (this.showYearly) {
      this.spacesData.push({ id: 5, name: 'Yearly' });
    }
    this.applyDefaultType(this.defaultType);
    this.applyDefaultIndex(this.defaultIndex);
  },

  computed: {
    getYear() {
      return dayjs(this.year).year();
    },
    showArrows() {
      if (this.slideType === 'Initial') {
        return [false, true];
      }
      const show = [true, true];

      if (this.slideIndex === 0) {
        show[0] = false;
      }
      const arrLen = this.sliderData[this.slideType].length;

      if (this.slideIndex >= arrLen - 1) {
        show[1] = false;
      }

      return show;
    },

    calcDates() {
      if (this.slideType === 'Range') {
        return this.defaultRange;
      }
      if (this.slideType === 'Initial') {
        return ['2010-01-01', '2110-01-01'];
      }

      // YYYY MM DD
      const year = this.getYear;
      let start = '';
      let end = '';
      let from = '';
      let to = '';

      if (this.slideType === 'Monthly') {
        start = this.slideIndex + 1;
        end = this.slideIndex + 1;
      }

      if (this.slideType === 'Quarterly') {
        // 0 => 1 2 3
        // 1 => 4 5 6
        // 2 => 7 8 9
        // 3 => 10 11 12

        start = this.slideIndex + this.slideIndex + (this.slideIndex + 1);
        end = start + 2;
      }

      if (this.slideType === 'Yearly') {
        start = 1;
        end = 12;
      }

      const mon = start < 10 ? `0${start}` : start;
      const nexmon = end < 10 ? `0${end}` : end;

      from = `${year}-${mon}-01`;
      to = dayjs(`${year}-${nexmon}-01`).endOf('month').format('YYYY-MM-DD');
      if (this.slideType !== 'Weekly') {
        return [from, to];
      } else {
        return this.getWeekByIndex(this.slideIndex, this.getYear);
      }
    },

    totalCommuters() {
      if (!this.data || !this.data.no_commuters) return 0;

      // const all = [];

      // Object.entries(this.data).forEach(([key, val]) => {
      //   if (key !== 'no_commuters') {
      //     // { label: 'Drive Alone', value: 20 },
      //     const monts = sortAndNameMonthesAndCommuters(val.all);
      //     const commutersVals = monts.map((m) => Object.values(m)[1] || 0);
      //     const total = commutersVals.reduce(
      //       (accumulator, currentValue) => accumulator + currentValue,
      //       0,
      //     );
      //     all.push(total);
      //   }
      // });

      // const sumAll = all.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      // console.log('chartData', sumAll);
      return `${this.data.no_commuters} Commuters`;
      // return `${sumAll} Commuters`;
    },

    chartData() {
      if (!this.data) return null;

      let data = [];
      let allTotal = 0;

      Object.entries(this.data).forEach(([key, val]) => {
        if (key !== 'no_commuters' && key !== 'custom_destructed') {
          // { label: 'Drive Alone', value: 20 },
          const monts = sortAndNameMonthes(val.all);
          let total = 0;
          monts.forEach((m) => {
            total += +Object.values(m)[0] || 0;
          });

          allTotal += total;
          data.push({ label: key, value: total });
        }
        if (key === 'custom_destructed') {
          // { label: 'Drive Alone', value: 20 },
          let total = 0;
          Object.keys(val).forEach((m) => {
            total += val?.[m];
          });

          allTotal += total;

          Object.keys(val).forEach((m) => {
            data.push({ label: `${m} - CM*`, value: val?.[m] });
          });

        }
      });

      if (!allTotal) return 0;

      if (allTotal) {
        data = data.map((d) => ({
          ...d,
          default_value: +d.value,
          value: (+d.value / allTotal) * 100,
        }));
      } else {
        data = data.map((d) => ({
          ...d,
          default_value: +d.value,
          value: (1 / data.length) * 100,
        }));
      }
      this.forceRerender();
      return data;
    },
    chartConnected() {
      return this.$store.state?.stats?.connectedCharts ?? false;
    },
  },

  watch: {
    calcDates: {
      handler(val) {
        if (val) {
          if (this.slideType === 'Initial') {
            this.$emit('updateDefaultType', 'Initial');
            this.$emit('setDate', val, this.slideType);
          } else {
            this.$emit('setDate', val, this.slideType);
          }
        }
      },
      deep: true,
    },
    startMonth(val) {
      if (val !== 1) {
        console.log('OOO startMonth', val);
        if (this.defaultIndex === null) {
          this.slideIndex = val - 1;
        }
      }
    },
    defaultIndex(val) {
      this.applyDefaultIndex(val);
    },
    defaultType(val) {
      this.applyDefaultType(val);
    },
    defaultYear(val) {
      this.applyDefaultYear(val);
    },
    year(val) {
      if (val) {
        this.sliderData.Weekly = this.getWeeksOfYear(this.getYear);
      }
    },
  },
  methods: {
    getSpotForType(type) {
      const spots = {
        Weekly: 10,
        Monthly: 1,
        Quarterly: 2,
        Initial: 4,
        Yearly: 5,
        Range: 6,
      };

      return spots[type] || 1;
    },
    applyDefaultType(type) {
      if (!type || this.slideType === type) return;

      if (type === 'Range' && !this.spacesData.find((item) => item.id === 6)) {
        this.spacesData.push({ id: 6, name: 'Custom Range' });
      }
      this.slideType = type;
      this.spot = this.getSpotForType(type);
      this.applyDefaultIndex(this.defaultIndex);
    },
    applyDefaultIndex(index) {
      if (index === null || index === undefined) {
        if (this.startMonth !== 1) {
          this.slideIndex = this.startMonth - 1;
        }
        return;
      }

      if (Number.isInteger(index) && this.slideIndex !== index) {
        this.slideIndex = index;
      }
    },
    applyDefaultYear(value) {
      if (!value) return;

      const nextYear = dayjs(value);
      if (!nextYear.isValid() || dayjs(this.year).isSame(nextYear, 'year')) return;

      this.year = nextYear;
    },
    getCurrentWeekIndex(year = null) {
      /**
       * Get the current week index (0-based) for the specified year
       *
       * @param {number|null} year - Year to get current week index from. Defaults to current year.
       * @returns {number|null} Zero-based index of current week, or null if current date is not in the specified year
       */
      const today = new Date();

      if (year === null) {
        year = today.getFullYear();
      }

      // If asking for a different year than current, return null
      if (today.getFullYear() !== year) {
        return null;
      }

      // Find the first Monday of the year
      const janFirst = new Date(year, 0, 1);
      const dayOfWeek = janFirst.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      const firstMonday = new Date(janFirst);
      firstMonday.setDate(janFirst.getDate() - daysToMonday);

      // Find which Monday of the current week
      const todayDayOfWeek = today.getDay();
      const daysToCurrentMonday = todayDayOfWeek === 0 ? 6 : todayDayOfWeek - 1;
      const currentMonday = new Date(today);
      currentMonday.setDate(today.getDate() - daysToCurrentMonday);

      // Use UTC day counts so DST shifts can't skew the week math
      const diffDays = Math.round(
        (Date.UTC(
          currentMonday.getFullYear(),
          currentMonday.getMonth(),
          currentMonday.getDate(),
        ) -
          Date.UTC(firstMonday.getFullYear(), firstMonday.getMonth(), firstMonday.getDate())) /
          (24 * 60 * 60 * 1000),
      );

      return Math.max(0, Math.round(diffDays / 7));
    },
    getWeeksOfYear(year = null) {
      /**
       * Generate a list of week strings for the given year (or current year if null).
       * Each week runs from Monday to Sunday.
       * Format: "Feb 03rd 2025 - Feb 10th 2025"
       *
       * @param {number|null} year - Year to generate weeks for. Defaults to current year.
       * @returns {string[]} Array of formatted week strings
       */
      if (year === null) {
        year = this?.year ?? new Date().getFullYear();
      }

      // Find the first Monday of the year (or the Monday of the week containing Jan 1)
      const janFirst = new Date(year, 0, 1); // Month is 0-indexed
      // Calculate days to subtract to get to Monday (0=Sunday, 1=Monday, etc.)
      const dayOfWeek = janFirst.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Convert Sunday=0 to Monday=0
      const firstMonday = new Date(janFirst);
      firstMonday.setDate(janFirst.getDate() - daysToMonday);

      const weeks = [];
      const currentMonday = new Date(firstMonday);

      // Generate weeks until we're in the next year
      while (currentMonday.getFullYear() <= year) {
        const sunday = new Date(currentMonday);
        sunday.setDate(currentMonday.getDate() + 6);

        // If the week starts in the target year, include it
        if (currentMonday.getFullYear() === year || sunday.getFullYear() === year) {
          const mondayStr = this.formatDateWithOrdinal(currentMonday);
          const sundayStr = this.formatDateWithOrdinal(sunday);

          const weekString = `${mondayStr} - ${sundayStr}`;
          weeks.push(weekString);
        }

        // Move to next Monday
        currentMonday.setDate(currentMonday.getDate() + 7);
      }

      return weeks;
    },

    formatDateWithOrdinal(date) {
      /**
       * Format a date as "Feb 03rd 2025"
       *
       * @param {Date} date - Date to format
       * @returns {string} Formatted date string
       */
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];

      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();

      // Add ordinal suffix
      const ordinal = this.getOrdinalSuffix(day);

      return `${month} ${day.toString().padStart(2, '0')}${ordinal} ${year}`;
    },
    getWeekByIndex(index, year = null) {
      /**
       * Get a specific week by its index (0-based)
       *
       * @param {number} index - Zero-based index of the week to retrieve
       * @param {number|null} year - Year to get week from. Defaults to current year.
       * @returns {Object|null} Object with formatted string and YYYY-MM-DD dates, or null if index is out of range
       */
      if (year === null) {
        year = new Date().getFullYear();
      }

      // Validate index
      if (index < 0 || !Number.isInteger(index)) {
        return null;
      }

      // Find the first Monday of the year
      const janFirst = new Date(year, 0, 1);
      const dayOfWeek = janFirst.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      const firstMonday = new Date(janFirst);
      firstMonday.setDate(janFirst.getDate() - daysToMonday);

      // Calculate the Monday of the requested week
      const targetMonday = new Date(firstMonday);
      targetMonday.setDate(firstMonday.getDate() + index * 7);

      // Check if this week exists in the target year
      const targetSunday = new Date(targetMonday);
      targetSunday.setDate(targetMonday.getDate() + 6);

      // If neither Monday nor Sunday are in the target year, return null
      if (targetMonday.getFullYear() !== year && targetSunday.getFullYear() !== year) {
        return null;
      }

      // If we've gone too far into the next year, return null
      if (targetMonday.getFullYear() > year) {
        return null;
      }

      const mondayStr = this.formatDateWithOrdinal(targetMonday);
      const sundayStr = this.formatDateWithOrdinal(targetSunday);
      const mondayISO = this.formatDateISO(targetMonday);
      const sundayISO = this.formatDateISO(targetSunday);

      return [mondayISO, sundayISO];
    },
    formatDateISO(date) {
      /**
       * Format a date as "YYYY-MM-DD"
       *
       * @param {Date} date - Date to format
       * @returns {string} ISO formatted date string
       */
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    getOrdinalSuffix(num) {
      /**
       * Get the ordinal suffix for a number (st, nd, rd, th)
       *
       * @param {number} num - Number to get suffix for
       * @returns {string} Ordinal suffix
       */
      const lastDigit = num % 10;
      const lastTwoDigits = num % 100;

      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
        return 'th';
      }

      switch (lastDigit) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    },
    handleChange(value) {
      this.debouncedHandleChange(value);
    },
    setInput(val) {
      if (val && val.spots) {
        const typeid = val.spots.value;
        this.spot = val.spots.value;
        const spac = this.spacesData.find((d) => d.id === typeid);
        this.$emit('updateDefaultType', spac.name);
        if (spac && this.slideType !== spac.name) {
          this.slideIndex = 0;
          if (spac && spac.name) {
            this.slideType = spac.name;
          }
          if (spac.name === 'Weekly') {
            this.year = dayjs();
            this.slideIndex = this.getCurrentWeekIndex(this.getYear) ?? 0;
          }
        }
      }
      if (val && val.searchDay) {
        this.searchDay = val.searchDay.value;
        this.$store.commit(STATS.SET_EMPLOYER_DAY_SEARCH_QUERY, val.searchDay.value);
      }
    },
    goNextStep() {
      if (this.spot === 4) {
        this.slideType = 'Monthly';
        this.slideIndex = 0;
        return;
      }
      if (this.spot !== 3) {
        const maxInx = this.sliderData[this.slideType].length - 1;
        if (this.slideIndex < maxInx) {
          this.slideIndex += 1;
        }
      }
    },
    goToCurrentWeek() {
      const index = this.getCurrentWeekIndex(this.getYear);

      if (index !== null) {
        this.slideIndex = index;
      }
    },
    goPrevStep() {
      if (this.spot !== 3) {
        if (this.slideIndex > 0) {
          this.slideIndex -= 1;
        }
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
};
</script>

<style scoped>
.fade-in-out {
  animation: fadeInOut 0.4s ease-in-out;
}

@keyframes fadeInOut {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
</style>
